module.exports = __webpack_public_path__ + "static/img/bg-id.b27c5fa3.png";